import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const playlistSongImporterSelectors = importerSelectors(
  'playlistSong.importer',
)

export default playlistSongImporterSelectors
